import React from 'react';

/** 转义正则特殊字符 */
function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * 将 text 中与 keyword 匹配（大小写不敏感）的片段用 mark 高亮。
 * keyword 为空时原样返回 text。
 */
export function highlightText(
  text: string | undefined | null,
  keyword: string | undefined | null,
): React.ReactNode {
  const value = text ?? '';
  const kw = keyword?.trim();
  if (!kw) return value || '-';

  const re = new RegExp(`(${escapeRegex(kw)})`, 'gi');
  const parts = value.split(re);
  if (parts.length <= 1) return value || '-';

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} style={{ background: '#ffe58f', padding: 0 }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        ),
      )}
    </>
  );
}
